export class Main {
    private static instance: Main = new Main();

    private initPromise:Promise<any>;
    private initResolve:((data:any)=>void)|undefined = undefined;

    private initData: Object|null = null;
    private mainWindow: Window | null = null;
    private mainWindowRequester: { data: {} }[] = [];
    private intercomListener: { [fqClassName: string]: IntercomListener } = {};
    private requestResponder: { [requestId: number]: ReqestQueueElement } = {};
    private origin: string|null=null;

    constructor() {
        this.initPromise=new Promise<any>(
            resolve => this.initResolve=resolve
        );
        this.initializeMessageBus();
    }

    public static async getInitData(): Promise<any> {
        if(this.instance.initData===null){
            return this.instance.initPromise;
        }

        return this.instance.initData;
    }

    public static async postMessage(data: AsyncJavaRequest): Promise<any> {
        return this.instance.postMessage(data);
    }

    public static registerIntercomListener(fqClassName: string, listener: IntercomListener) {
        this.instance.intercomListener[fqClassName] = listener;
    }

    public async postMessage(data: AsyncJavaRequest): Promise<any> {
        const res = new Promise((resolve, reject) => {
            this.requestResponder[data.requestId] = {
                reject, resolve
            };
        });
        if (this.mainWindow === null) {
            this.mainWindowRequester.push({data: data});
        } else {
            this.postMessageToInitializedMainWindow(data);
        }
        return res;
    }

    public static getOrigin():string|null{
        return this.instance.origin;
    }

    private postMessageToInitializedMainWindow(data: {}): void {
        (<Window>this.mainWindow).postMessage(JSON.stringify(data), "*");
    }

    private initializeMessageBus() {
        (<any>window).addEventListener("message", (event: any) => {
            this.handleMessages(event)
        }, false);
    }

    private handleMessages(event: any): void {
        // console.log("--", event);
        if (event && event.data && event.data.type) {
            let req;
            let listener;
            let responder;
            switch (event.data.type) {
                case "init":
                    console.debug("init received", event);
                    this.mainWindow = event.source;
                    req = this.mainWindowRequester.pop();
                    while (req) {
                        this.postMessageToInitializedMainWindow(req.data);
                        req = this.mainWindowRequester.pop();
                    }
                    this.initData = event.data;
                    if(this.initResolve) {
                        this.initResolve(this.initData);
                    }
                    if(event.data["sourcehref"]){
                        this.origin = event.data["sourcehref"];
                    }
                    break;

                case "ib":
                    console.debug("Intercom ... Message:", event);
                    responder = this.requestResponder[event.data.requestId];

                    if (responder) {
                        responder.resolve(event.data.result);
                    }

                    listener = this.intercomListener[event.data.ib];
                    if (listener) {
                        listener(event.data);
                    } else {
                        console.warn(":^: was a unregistered Intercom");
                    }
                    break;
                case "webpackOk":
                    break;
                default:
                    console.warn("uninitialized Message type:", event);

            }
        } else {
            console.error("unknown event posted: ", event);
        }
    }

}

interface ReqestQueueElement {
    resolve: (data: any) => void;
    reject: (error: any) => void;
}

export interface IntercomListener {
    (data: {}): void
}

export type RequestTypes = "call" | "query";

export class AsyncJavaRequest {
    private static RequestId: number = 0;

    public request: RequestTypes;
    public action: any;
    public requestId: number;
    public data?: string;

    constructor(request: RequestTypes, action: string, data?: string) {
        this.requestId = AsyncJavaRequest.RequestId++;
        this.request = request;
        this.action = action;
        this.data = data;
    }
}
